import React, { ImgHTMLAttributes } from 'react'

import { styled, ImageProps } from 'tamagui'

const GuildImageElement = React.forwardRef<
  HTMLImageElement,
  {
    src?: string
    fetchPriority?: 'high' | 'low' | 'auto'
  } & ImgHTMLAttributes<HTMLImageElement>
>(({ src, loading = 'lazy', fetchPriority, ...props }, ref) => {
  // fetchpriority must be lowercase — React 18 doesn't map camelCase fetchPriority
  // to the HTML attribute when Tamagui's styled() wraps the element.
  return (
    <img
      {...props}
      ref={ref}
      src={src}
      loading={loading}
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
    />
  )
})
GuildImageElement.displayName = 'GuildImageElement'

export const Image = styled(GuildImageElement, {
  name: 'GuildImage',
  acceptsClassName: true,
})
